// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071953/js/" + chunkId + "." + {"44":"c7518862","225":"ae5b8a36","481":"098a4fd2","486":"85f8be30","770":"9a2d8216"}[chunkId] + ".0.6003500433547889.chunk.js";
};